export type RequestQuickSearchKind = 'id' | 'domain'

const NUMERIC_REQUEST_ID_REGEX = /^\d+$/

export const resolveRequestQuickSearchKind = (
  rawValue: string,
): RequestQuickSearchKind | null => {
  const value = rawValue.trim()

  if (!value) {
    return null
  }

  if (NUMERIC_REQUEST_ID_REGEX.test(value)) {
    return 'id'
  }

  if (value.includes('.')) {
    return 'domain'
  }

  return null
}

export const getSanitizedQuickSearchValue = (rawValue: string): string => rawValue.trim()
